var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLazarusName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 37,
    viewBox: "0 0 198 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_3595_17210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4636 20.2741V6.97395H44.3476V17.7946C44.3476 19.7126 45.0955 21.5523 46.4271 22.9089C47.7587 24.2655 49.5645 25.0274 51.4473 25.0274H61.0902V20.8342H49.0134C48.7997 20.6166 48.6786 20.4931 48.4649 20.2754L48.4636 20.2741Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.195 9.09109C134.863 10.4477 134.115 12.2874 134.115 14.2054V25.0261H138.231V11.7259C138.445 11.5069 138.566 11.3848 138.78 11.1671H150.856V6.97395L141.213 6.97395C139.331 6.97395 137.525 7.73586 136.193 9.09242L136.195 9.09109Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6021 6.98059C73.4119 6.98059 71.4106 8.24158 70.4321 10.2379L63.184 25.0261L67.7846 25.0261L75.1109 10.0786H76.0933L83.4197 25.0261H88.0203L80.7721 10.2379C79.7936 8.24158 77.7923 6.98059 75.6021 6.98059Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.032 6.98059C117.842 6.98059 115.84 8.24158 114.862 10.2379L107.614 25.0261H112.214L119.541 10.0786H120.523L127.849 25.0261H132.45L125.202 10.2379C124.223 8.24158 122.222 6.98059 120.032 6.98059Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.646 6.98059L165.32 21.928H164.338L157.011 6.98059H152.411L159.659 21.7687C160.637 23.7651 162.639 25.0261 164.829 25.0261C167.019 25.0261 169.02 23.7651 169.999 21.7687L177.247 6.98059H172.646Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.667 14.9952C106.063 13.5762 106.492 10.23 104.531 8.23362C103.739 7.42658 102.665 6.97395 101.545 6.97395H89.7349V11.1671L102.277 11.1671L102.415 11.6887L90.561 18.7224C88.4985 19.9462 88.3395 22.9222 90.2613 24.3664C90.832 24.7951 91.5225 25.0274 92.2326 25.0274H105.767V20.8342H94.8215L94.6834 20.3126L103.664 14.9952H103.667Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.245 14.9952C177.849 13.5762 177.42 10.23 179.381 8.23362C180.173 7.42658 181.247 6.97395 182.367 6.97395H194.177V11.1671H181.635C181.562 11.4432 181.57 11.4126 181.497 11.6887L193.351 18.7224C195.414 19.9462 195.573 22.9222 193.651 24.3664C193.08 24.7951 192.39 25.0274 191.679 25.0274H178.145V20.8342H189.091C189.164 20.5582 189.156 20.5887 189.229 20.3126L180.248 14.9952H180.245Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6866 14.6169L6.05215 16.9743C3.85673 17.5742 2.5525 19.8732 3.14143 22.1098L13.4019 19.3091C15.2208 18.8127 16.7713 17.6008 17.712 15.9389C18.654 14.2784 18.9081 12.3033 18.4208 10.4516L15.6716 0C13.4762 0.599967 12.172 2.89895 12.7609 5.13556L15.0749 13.932L14.6866 14.6169Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4663 14.6169L35.1008 16.9743C37.2962 17.5742 38.6004 19.8732 38.0115 22.1098L27.751 19.3091C25.9321 18.8127 24.3817 17.6008 23.441 15.9389C22.4989 14.2784 22.2449 12.3033 22.7322 10.4516L25.4813 0C27.6768 0.599967 28.981 2.89895 28.3921 5.13556L26.0781 13.932L26.4663 14.6169Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1863 24.3265L13.8619 30.7616C12.2528 32.3982 9.64692 32.3969 8.04041 30.7576L15.5557 23.1107C16.8873 21.7554 18.6944 20.9949 20.5771 20.9962C22.4599 20.9962 24.2657 21.7607 25.596 23.1173L33.1021 30.7735C31.493 32.4102 28.8872 32.4088 27.2807 30.7695L20.9641 24.3265H20.1863Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3595_17210",
    x: 0.6,
    y: 0,
    width: 196.8,
    height: 36.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3595_17210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3595_17210",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLazarusName);
export default __webpack_public_path__ + "static/media/LazarusName.d726c143f60f850c7b0967f95a5332e6.svg";
export { ForwardRef as ReactComponent };